import React, { Component } from "react";
import { connect } from "react-redux";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import Viewer from "./components/post/viewer/Viewer";
import Category from "./components/post/category/Category";
import PrivateSite from "./components/private-site/PrivateSite";
import PaymentSuccess from "./components/payment-success/PaymentSuccess";
import MFA from "./components/MFA/MFA";
import { PrivateRoute } from "./components/private-route/PrivateRoute";
import Logout from "./components/logout/Logout";
import { Manager as ContentManager } from "./components/content-manager/Manager";
import ClientSelector from "./components/client-selector/ClientSelector";
import CustomClientSelector from "./components/client-selector/CustomClientSelector";
import ActivityLogInit from "./components/activity-log-init/ActivityLogInit";
import Shared from "./components/public-shared/Shared";
import BunkeyHostEmbed from "./components/bunkey-host-embed/BunkeyHostEmbed";
import AcceptInvitation from "./components/public-accept-invitation/AcceptInvitation";
import { publicToken } from "./actions/PublicAction";
import Page404 from "./page404/Page404";
import Evaluation from "./components/evaluation/Evaluation";
import history from "./History";
import loadingImagen from "./assets/images/logo-animado-2.gif";
import { PageView, initGA } from "../src/components/Tracking/Tracking";
import "./App.css";
import "./components/loading/loading.css";
import FreeAccountLanding from "./components/free-account-landing/freeAccountLanding";
import ScrollToTop from "./utils/ScrollToTop";
import LoginGN from "./components/custom-clients/login-gn";

class App extends Component {
  componentDidMount() {
    const savedColor = localStorage.getItem("primaryColor");
    // Apply the saved color value to the CSS property
    document.documentElement.style.setProperty(
      "--primary-color",
      savedColor,
      "important"
    );
    // localStorage.clear();
    this.props.publicToken();
    if (process.env.REACT_APP_BUNKEY_ENV === "production") {
      initGA();
      PageView();
    }
  }

  componentDidUpdate(prevProps) {
    if (process.env.REACT_APP_BUNKEY_ENV === "production") {
      PageView();
    }
  }

  render() {
    const { token, user } = this.props;
    const current = window.location.href;

    if (current.includes("/embed/")) {
      return (
        <Router history={history}>
          <Switch>
            <Route exact path="/embed/:id" component={BunkeyHostEmbed} />
            <Route
              exact
              path="/embed/:id/:quality"
              component={BunkeyHostEmbed}
            />
          </Switch>
        </Router>
      );
    } else {
      if (!token)
        return (
          <div className="loading-container">
            <img src={loadingImagen} alt="Loading" />
          </div>
        );

      // console.log("app.user", user);
      return (
        <Router history={history}>
          <ScrollToTop>
            <Switch>
              {/* <Route exact path="/free-landing" component={FreeAccountLanding} /> */}
              <PrivateRoute
                authed={user}
                path="/security-mfa/"
                component={MFA}
              />
              <PrivateRoute
                authed={user}
                path="/home/"
                component={PrivateSite}
              />
              <PrivateRoute
                authed={user}
                path="/payment-success/"
                component={PaymentSuccess}
              />
              <PrivateRoute
                authed={user}
                path="/manager"
                component={ContentManager}
              />
              <PrivateRoute
                exact
                authed={user}
                path="/client-selector"
                component={ClientSelector}
              />
              <PrivateRoute
                exact
                authed={user}
                path="/custom-client-selector"
                component={CustomClientSelector}
              />
              <PrivateRoute
                exact
                authed={user}
                path="/activity-log-init"
                component={ActivityLogInit}
              />
              <Route path="/" exact authed={user}>
                {user && token && user.role ? (
                  user.role === "cmo" ? (
                    <Redirect to="/manager/cms" />
                  ) : user.canPass ? (
                    <Redirect to="/client-selector" />
                  ) : (
                    <FreeAccountLanding />
                  )
                ) : (
                  <FreeAccountLanding />
                )}
              </Route>
              <Route exact path="/" component={FreeAccountLanding} />
              <Route path="/gnbrands" exact authed={user}>
                {user && token && user.canPass ? (
                  <Redirect to="/custom-client-selector" />
                ) : (
                  <LoginGN />
                )}
              </Route>
              <Route exact path="/gnbrands" component={LoginGN} />
              <Route exact path="/viewer/:id" component={Viewer} />
              <Route exact path="/category/:category" component={Category} />
              <Route exact path="/logout" component={Logout} />
              <Route exact path="/archivos-compartidos" component={Shared} />
              <Route
                exact
                path="/usuario-invitado"
                component={AcceptInvitation}
              />
              <Route exact path="/evaluation" component={Evaluation} />
              <Route component={Page404} />
            </Switch>
          </ScrollToTop>
        </Router>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    token: state.public.token,
    user: state.authUser.user
  };
};

const mapDispatchToProps = {
  publicToken
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
